import { render, staticRenderFns } from "./BankCollections.vue?vue&type=template&id=3da761a7&"
import script from "./BankCollections.vue?vue&type=script&lang=js&"
export * from "./BankCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports